<template lang="html">
  <div class="text__title">
    <component :is="tag" :class="{ text__inner: true, bold: bold }">
      <!-- @slot Безымянный слот. Используется для вставки текста-->
      <slot/>
    </component>
  </div>
</template>

<script>
export default {
  name: 'bimTextH3',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h3'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__title .text__inner {
  margin: 0;
  font-size: 50px;
  font-weight: normal;
  line-height: 1.08;
  letter-spacing: normal;
}

.text__title .text__inner.bold {
  font-weight: bold;
}
</style>
